import React, { Component } from "react";

class AppleFinancial extends Component {
    render() {
        return (
            <div className="portfolio-area" >
                <div className="row">
                    {/* <div className="container" style={{margin: 0, padding: 0}}> */}
                    <div className='col-lg-4 box-Apple-Esq'>
                            </div>
                            <div className='col-lg-4 box-AppleCenter'>
                            <h2 style={{fontWeight: 100}}>Equipamentos Apple<br />O melhor aliado do seu orçamento</h2>
                            <p style={{color:'#fff', fontWeight: 100}}>Ao utilizar equipamentos Apple, os seus colaboradores terão maior sentido de propriedade e serão mais cuidadosos no uso dos dispositivos, o que finalmente reduz os custos de manutenção do hardware, e ainda, a sua empresa terá um parque de TI de última geração.</p>
                            </div>
                            <div className='col-lg-4 box-Apple-Dir'>
                            </div>
                </div>
            </div>
            
        )

    }
}
export default AppleFinancial;
